.ds{border:1px solid #ddd;}